var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88 1.38001L0.749527 8.51048C0.269609 8.9904 -4.76837e-06 9.6413 -4.76837e-06 10.32C-4.76837e-06 10.9987 0.26961 11.6496 0.749528 12.1295L7.88 19.26C9.05 20.43 10.95 20.43 12.12 19.26L3.18 10.32L12.12 1.38001C10.95 0.210012 9.05 0.210012 7.88 1.38001Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.782a943965ef0a1fa15035cf0049fac3.svg";
export { ForwardRef as ReactComponent };